import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import CenteredFlex from '@components/Shared/CenteredFlex';
import ContactMeForm from '@components/Shared/ContactMeForm';
import { colorsGrey } from '@src/theme/chakraTheme/colors';

const ContactForm: React.FC = () => {
  return (
    <CenteredFlex pt="35px" direction="column" px={5}>
      <Text
        mb="35px"
        color={colorsGrey[300]}
        fontFamily="montserrat"
        fontWeight="light"
        textAlign="center"
        fontSize="lg"
      >
        Write, text or call me for any suggestion, project or question
      </Text>
      <Box w="100%">
        <ContactMeForm />
      </Box>
    </CenteredFlex>
  );
};

export default ContactForm;
